import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WsService } from '../../services/ws/ws.service';
import { SessionService } from '../../services/session.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import {
     ISchedulerBrowseFilters,
     IWsPlanningBrowsePlanningItemRes,
} from '../../services/ws/ws.typings';
import { MatDialog } from '@angular/material/dialog';
import { BookComponent } from '../book/book.component';
import { catchError } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { DataService } from '../../services/data.service';
import { ITask } from '../planning/planning.component';
import { ArrayToDictionaryBy } from '../../utils/array-to-dictionary';
import { WelcomeDialogComponent } from '../welcome-dialog/welcome-dialog.component';
import { TV_SCREEN } from '../../constants';

@Component({
     selector: 'app-highlights',
     templateUrl: './highlights.component.html',
     styleUrls: ['./highlights.component.scss'],
})
export class HighlightsComponent implements OnInit {
     isTvScreen = TV_SCREEN;
     highlights = {
          now: [] as IWsPlanningBrowsePlanningItemRes[],
          later: [] as IWsPlanningBrowsePlanningItemRes[],
          tomorrow: [] as IWsPlanningBrowsePlanningItemRes[],
     };
     appCfg = { ...window.app };
     tasks$: Subscription;
     tasks: ITask[] = [];
     tasksDictionary: { [key: number]: ITask };

     constructor(
          private router: Router,
          private ws: WsService,
          private session: SessionService,
          private toastrService: ToastrService,
          private dataService: DataService,
          public dialog: MatDialog
     ) {}

     ngOnInit() {
          this.load();
          this.tasks$ = this.dataService.tasks$.subscribe((data) => {
               this.tasks = data || [];
               this.tasksDictionary = ArrayToDictionaryBy(this.tasks, 'id');
          });
          if (!this.session.isInitialQuestionAnswered()) {
               this.openWelcomeDialog();
          }
     }

     load() {
          let d = moment();
          let nowLimit = moment().add(15, 'minutes');
          let t = moment().add(1, 'day');

          this.ws.planning
               .browsePlanning({
                    dates: d.format('YYYY-MM-DD'),
               } as ISchedulerBrowseFilters)
               .then(async (data) => {
                    try {
                         if (data.length) {
                              // Activities that are already started or that are starting soon
                              let now = [];
                              let later = [];
                              let len = data.length;
                              for (let i = 0; i < len; i++) {
                                   let v = data[i];
                                   let st = moment(v.start);
                                   if (st.isBefore(nowLimit)) {
                                        now.push(v);
                                   } else {
                                        later.push(v);
                                   }
                              }
                              this.highlights.now = now;
                              this.highlights.later = later;
                              this.highlights.tomorrow = [];
                         } else {
                              let res = await this.ws.planning.browsePlanning({
                                   dates: d.format('YYYY-MM-DD'),
                                   stackBy: 'date-hour',
                              } as ISchedulerBrowseFilters);
                              if (res.length) {
                                   this.highlights.tomorrow = res.slice(0, 8);
                              }
                         }
                    } catch (err) {
                         this.toastrService.error(
                              window.appLang.GENERIC_ERROR_MSG
                         );
                         console.error(err);
                    }
               })
               .catch((err) => {
                    this.toastrService.error(window.appLang.GENERIC_ERROR_MSG);
                    console.error(err);
               });
     }

     openWelcomeDialog() {
          this.dialog
               .open(WelcomeDialogComponent, {
                    data: null,
                    panelClass: 'dialog--no-padding',
                    closeOnNavigation: false,
                    disableClose: true,
               })
               .afterClosed()
               .subscribe((data) => {});
     }

     openActivity(scheduledTask) {
          let data = {
               scheduledTask: { ...scheduledTask },
               task: this.tasks.find(
                    (task) => task.id === scheduledTask.idActivity
               ),
          };
          this.dialog
               .open(BookComponent, {
                    data: data,
                    panelClass: 'dialog--no-padding',
               })
               .afterClosed()
               .pipe(catchError((err) => of(err.message || '')))
               .subscribe(() => {});
     }
}
